/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-orderlist-controls{width:100px}  .ui-orderlist-list-container{width:calc(100% - 100px)}  .ui-orderlist-list-container   .ui-orderlist-list{width:100%}  .reorder-grid-checkbox{display:block;text-align:center;vertical-align:middle}  input[type=text]{width:100%}  .ui-dropdown{min-width:25px}  .ui-orderlist-controls>button:first-of-type{top:23px}  .ui-orderlist-controls>button:nth-of-type(2){bottom:23px}p-autocomplete[_ngcontent-%COMP%]     .ui-autocomplete-multiple-container{height:100%;overflow:auto;width:calc(100% - 25px)}"];
export { styles as styles };
